export default "__VITE_ASSET__xQY3XY4s__"